export default function getFontSizeOverride(state) {
  return state.fontSizeOverride;
}
